import { InputText } from "@bluframe/blublocks"
import { Template } from "@bluframe/mightychroma-mightytool-frontend-types"

import { ComponentProps } from "."
import { HtmlTextArea, Inputs } from "./styled"

const EditInputs = ({
  errors,
  footerIdRef,
  headingIdRef,
  htmlRef,
  isTemplate,
  item,
  subjectRef
}: Pick<
  ComponentProps,
  | "errors"
  | "footerIdRef"
  | "headingIdRef"
  | "htmlRef"
  | "isTemplate"
  | "item"
  | "subjectRef"
>) => (
  <Inputs>
    {isTemplate ? (
      <>
        <InputText
          defaultValue={(item as Template)?.subject}
          error={Boolean(errors?.subject)}
          errorText={errors?.subject}
          inputId="subject"
          label="Subject"
          name="subject"
          ref={subjectRef}
          required
        />

        <InputText
          defaultValue={(item as Template)?.heading?.id}
          error={Boolean(errors?.headingId)}
          errorText={errors?.headingId}
          inputId="headingId"
          label="Heading ID"
          name="headingId"
          ref={headingIdRef}
        />
      </>
    ) : null}

    <HtmlTextArea
      defaultValue={item?.html}
      error={Boolean(errors?.html)}
      errorText={errors?.html}
      inputId="html"
      label="HTML"
      name="html"
      ref={htmlRef}
      required
    />

    {isTemplate ? (
      <InputText
        defaultValue={(item as Template)?.footer?.id}
        error={Boolean(errors?.footerId)}
        errorText={errors?.footerId}
        inputId="footerId"
        label="Footer ID"
        name="footerId"
        ref={footerIdRef}
      />
    ) : null}
  </Inputs>
)

export default EditInputs
